
const toggler = ({ target, toggleClass }, onAdd = null) => ({
    toggle() {
        if (target) {
            target.classList.toggle(toggleClass);
            if (target.classList.contains(toggleClass) && onAdd) {
                onAdd();
            }
        }
    },
    close() {
        if (target) {
            target.classList.remove(toggleClass);
        }
    },
});


const createTogglerFromDataAttributes = (toggleElement, defaultToggleClass = 'is-open', onOpen = null) => {
    const toggleClass = toggleElement.hasAttribute('data-class')
            ? toggleElement.getAttribute('data-class')
            : defaultToggleClass;
    const target = document.getElementById(toggleElement.getAttribute('data-target-id'));

    return toggler({ target, toggleClass }, onOpen);
};


export const initToggles = (elements) => {
    Array.from(elements).forEach((toggle) => {
        const targetToggler = createTogglerFromDataAttributes(toggle);

        toggle.addEventListener('click', (e) => {
            e.preventDefault();
            targetToggler.toggle();
        });
    });
};

export const initFormToggles = (formToggles) => {
    Array.from(formToggles).forEach((toggle) => {
        const focusElement = document.getElementById(toggle.getAttribute('data-focus-id'));
        const target = document.getElementById(toggle.getAttribute('data-target-id'));
        const targetToggler = createTogglerFromDataAttributes(toggle, 'is-open', () => {
            if (focusElement) {
                focusElement.focus();
            }
        });
        const selfToggler = toggler({ target: toggle, toggleClass: 'is-hidden' });

        toggle.addEventListener('click', (e) => {
            e.preventDefault();

            selfToggler.toggle();
            targetToggler.toggle();
            return false;
        }, 1);

        function closeIfClickedOutside(event) {
            if (!target.contains(event.target) && !toggle.contains(event.target)) {
                targetToggler.close();
                selfToggler.close();
            }
        }

        document.body.addEventListener('click', closeIfClickedOutside);
    });
};
